import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_POST_METHOD, API_GET_METHOD } from 'global_config/constant-global';
import { showMessage } from 'services/settings/message';

export async function fetchExtracReqByPatientID({ requestDate, patientID }) {
	try {
		const content = {
			method: API_GET_METHOD,
			// url: `/lab/SpecimenTracking/phlebo/requestdate/${requestDate}/patientid/${patientID}`,
			url: `/specimentracking/list`,
			 params : {
				p_request_datetime: requestDate,
				p_patient_demographics_id: patientID
			}
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			return data.RECORDS[0];
		} else {
			return [];
		}

	} catch (e) {
		// Message.error();
		showMessage(e);
		return false;
	}
}

export async function fetchExtracReqByPatientName({ requestDate, patientName }) {
	try {
		const content = {
			method: API_GET_METHOD,
			// url: `/lab/SpecimenTracking/phlebo/requestdate/${requestDate}/patientname/${patientName}`,
			url: `/specimentracking/list`,
			params : {
				p_request_datetime: requestDate,
				p_patient_name: patientName
			}
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			return data.RECORDS[0];
		} else {
			return [];
		}
	} catch (e) {
		showMessage(e);
		return false;
	}
}

export async function fetchExtracReqByDate({ requestDate }) {
	try {
		const content = {
			method: API_GET_METHOD,
			// url: `/lab/SpecimenTracking/phlebo/requestdate/${requestDate}`,
			url: `/specimentracking/list`,
			params : {
				p_request_datetime: requestDate,

			}
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			return data.RECORDS[0];
		} else {
			return [];
		}
	} catch (e) {
		showMessage(e);
		return false;
	}
}

export async function fetchRequestSpecimenToProcess(requestID) {
	try {
		const content = {
			method: API_GET_METHOD,
			// url: `/lab/SpecimenTracking/phlebo/requestid/${requestID}`, 
			url: `/specimentracking/requestinfo`,
			params : {
				p_request_header_id: requestID,

			}
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		// Handle new API response format
		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			return data.RECORDS[0];
		} else {
			return [];
		}
	} catch (e) {
		showMessage(e);
		return false;
	}
}

export async function checkinSpecimen(payload) {
	try {
		const content = {
			method: API_POST_METHOD,
			url: `/specimentracking/extractspecimen`,
			data: payload,
		};

		const response = await axiosLabAPI(content);
		const { data } = response;

		// Return standardized response format
		if (data && data.STATUSCODE === 200 && data.RECORDS && data.RECORDS[0]) {
			return {
				success: true,
				data: data.RECORDS[0],
				message: data.MESSAGE,
				statusCode: data.STATUSCODE
			};
		} else {
			return {
				success: false,
				data: null,
				message: data.MESSAGE || 'Extraction failed',
				statusCode: data.STATUSCODE
			};
		}

	} catch (e) {
		// if (e.response && e.response.status === 400) {
		// 	// Handle 400 status code error
		// 	// const errorMessage = e.response.data && eachDayOfInterval.response.data.error;

		// 	// Display the error message using Ant Design Message.error
		// 	showMessage(e);
		// } else {
		// 	// Handle other errors
		// 	Message.error('An error occurred');
		// }
		showMessage(e);
		console.log('🚀 ~ checkinSpecimen error:', e);
		return {
			success: false,
			data: null,
			message: 'An error occurred',
			statusCode: 500
		};
	}
}

export async function rejectSpecimenStatus(payload) {
	try {
		const content = {
			method: API_POST_METHOD,
			url: `/specimentracking/rejectspecimen`,
			data: payload,
		};

		const response = await axiosLabAPI(content);

		return response;
	} catch (e) {
		// if (error.response && error.response.status === 400) {
		// 	// Handle 400 status code error
		// 	const errorMessage = error.response.data && error.response.data.error;

		// 	// Display the error message using Ant Design Message.error
		// 	Message.error(errorMessage || 'Bad Request');
		// } else {
		// 	// Handle other errors
		// 	Message.error('An error occurred');
		// }
		showMessage(e);
		return false;
	}
}
